export default "__VITE_ASSET__CKT0lYsP__"